import type { PaymentSelection, WalletBrand } from "@utils/store/cart/useOrder";

/** 電子支付品牌清單（付款方式步驟的品牌鈕，順序即顯示順序；Apple Pay 只在 iPhone 出現）。 */
export const WALLET_BRANDS: { id: WalletBrand; label: string }[] = [
  { id: "apple_pay", label: "Apple Pay" },
  { id: "line_pay", label: "LINE Pay" },
  { id: "ipass_money", label: "一卡通 MONEY" },
];

/**
 * 付款方式選擇 → 送單 payment_method_ref。
 * 後端（app-api platform-orders.service）接受：已綁卡 id、'apple_pay' / 'line_pay' 字面量、'cash_on_delivery'。
 * 未選（null）回 null，由呼叫端決定要擋還是退回貨到付款。
 */
export const paymentSelectionToRef = (sel: PaymentSelection | null): string | null => {
  if (!sel) return null;
  switch (sel.type) {
    case "credit_card":
      return sel.paymentMethodId;
    case "electronic":
      return sel.brand;
    default:
      return "cash_on_delivery";
  }
};

/** 結帳頁「支付方式」列的顯示文字；未選回 null（呼叫端顯示「請選擇」）。 */
export const paymentSelectionLabel = (sel: PaymentSelection | null, monthly: boolean): string | null => {
  if (!sel) return null;
  switch (sel.type) {
    case "credit_card":
    case "electronic":
      return sel.label;
    case "monthly":
      return "月結";
    default:
      return monthly ? "月結" : "貨到付款";
  }
};
